<template>
  <h1 class="title">{{title}}</h1>
</template>

<script>
export default {
  name: 'Title',
  props: {
    title: String
  }
}
</script>

<style scoped>
  .title {
    background: linear-gradient( 45deg, rgb(215,81,0) 0%, rgb(253,135,3) 100%);
    box-shadow: 3.536px 3.536px 3px 0px rgba(0, 0, 0, 0.18);
    clip-path: polygon(0 0, 100% 0, 97% 100%, 0 100%);
    color: #fff;
    font-family: "futura-pt", sans-serif;
    font-size: 60px;
    font-weight: 400;
    left: 25px;
    letter-spacing: 3px;
    line-height: 89px;
    margin: 0;
    text-transform: uppercase;
    padding: 0 125px 0 70px;
    position: absolute;
    height: 88px;
    top: -52px;
    z-index: 1;
  }
</style>